import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { hoverMediaQuery, mediaQueryWidth, noHoverMediaQuery } from '../../common/breakpoints';
import { lightBlue, white } from '../../common/colors';

const shadowColor = 'rgba(0,0,0,0.5)';
const shadowOffset = '1';
const shadowBlur = '3px';

export const StyledPressMaterial = styled.div<{ row: number; column: number }>`
  position: relative;
  ${({ column, row }) =>
    css`
      -ms-grid-column: ${column};
      -ms-grid-row: ${row};
    `}

  ${mediaQueryWidth({ max: 'tablet' })`
    :not(:last-child) {
      padding-bottom: 40px;
    }
    :last-child {
      padding-bottom: 8px;
    }
  `}

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const StyledTitleContainer = styled.div<{ bottomPadding?: number }>`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0 20px;

  ${mediaQueryWidth({ min: 'tablet' })`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px 5px ${({ bottomPadding }: { bottomPadding?: number }) => bottomPadding || 30}px 40px;
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%);
  `};
`;

export const StyledTitle = styled.h3`
  margin: 0;
  font-weight: bold;
  padding-bottom: 5px;
  font-size: ${rem(20)};
  text-transform: uppercase;
  color: ${white};
  text-shadow: -${shadowOffset}px -${shadowOffset}px ${shadowBlur} ${shadowColor},
    ${shadowOffset}px -${shadowOffset}px ${shadowBlur} ${shadowColor},
    -${shadowOffset}px ${shadowOffset}px ${shadowBlur} ${shadowColor},
    ${shadowOffset}px ${shadowOffset}px ${shadowBlur} ${shadowColor};
`;

export const StyledSubtitle = styled.div`
  a {
    color: ${white};
    text-decoration: none;
    float: left;
    font-weight: 500;
    text-shadow: -${shadowOffset}px -${shadowOffset}px ${shadowBlur} ${shadowColor},
      ${shadowOffset}px -${shadowOffset}px ${shadowBlur} ${shadowColor},
      -${shadowOffset}px ${shadowOffset}px ${shadowBlur} ${shadowColor},
      ${shadowOffset}px ${shadowOffset}px ${shadowBlur} ${shadowColor};

    ${noHoverMediaQuery} {
      :active {
        color: ${lightBlue};
      }
    }

    ${hoverMediaQuery} {
      :hover {
        color: ${lightBlue};
      }
    }

    :not(:last-child) {
      padding-right: 28px;
    }
  }
`;
